module.exports = __webpack_public_path__ + "img/pix.e748686f.svg";